export default __webpack_public_path__ + "static/media/raspagem-ball.9df7753c.png";